import {
  Health,
  LotusFlower,
  OfficeWorkstation,
  PotPlant,
  Sleep,
  Wave,
} from '@unmind/design-system';

export const CategoryIcons = {
  sleep: Sleep,
  work: OfficeWorkstation,
  body: Health,
  grow: PotPlant,
  relax: LotusFlower,
  overcome: Wave,
  nature: Wave,
  music: Wave,
};

export const CategoryIconNames = {
  sleep: 'sleep',
  work: 'work',
  body: 'body-health',
  grow: 'grow',
  relax: 'relax-calmness',
  overcome: 'overcome-coping',
  nature: 'overcome-coping',
  music: 'overcome-coping',
} as const;

export type BaseCategoryKey = keyof typeof CategoryIcons;

// Map known keys (slugs) to their base category keys
export const CategoryKeyToBaseCategory: Record<string, BaseCategoryKey> = {
  // grow
  foundations: 'grow',
  'flourish-podcast': 'grow',
  'build-resilience': 'grow',
  'boost-happiness': 'grow',
  'nurture-relationships': 'grow',
  identity: 'grow',
  'grow-your-mind': 'grow',
  'become-your-best-self': 'grow',
  'exclusive-member-events1': 'grow',

  // sleep
  'sleep-skills': 'sleep',
  'sleep-sounds': 'sleep',
  'bedtime-stories-for-kids': 'sleep',
  'real-life-sleep-journeys': 'sleep',
  'bedtime-stories': 'sleep',
  'yoga-before-bed': 'sleep',
  'learn-to-sleep': 'sleep',

  // relax
  meditate: 'relax',
  mindfulness: 'relax',
  'keep-calm': 'relax',
  'relax-shorts': 'relax',
  soundscapes: 'relax',

  // work
  'made-for-managers': 'work',
  'neurodiversity-at-work': 'work',
  'work-shorts': 'work',
  'improve-focus': 'work',
  'boost-performance': 'work',
  'beat-work-issues': 'work',

  // body
  'manage-pain': 'body',
  workouts: 'body',
  'stretching-routines': 'body',
  menopause: 'body',
  'body-shorts': 'body',
  yoga: 'body',
  nutrition: 'body',

  // overcome
  'navigate-life-events': 'overcome',
  'financial-wellbeing': 'overcome',
  'real-stories': 'overcome',
  'manage-anxiety': 'overcome',
  'manage-your-mood': 'overcome',

  // nature and music
  'nature-sounds': 'nature',
};

const isBaseCategoryKey = (k: string): k is BaseCategoryKey =>
  k in CategoryIcons;

export const getCategoryIcon = (rawKey: string) => {
  const key = rawKey?.trim().toLowerCase();
  const mapped = CategoryKeyToBaseCategory[key] ?? key;
  const base: BaseCategoryKey = isBaseCategoryKey(mapped) ? mapped : 'overcome';

  return CategoryIcons[base] ?? Wave;
};
